import swg from './src/controllers/swg';
import {forceSWGLogout} from './src/controllers/user';
import meteringAuth from './src/controllers/meteringAuth';
import {version} from './package.json'

window.SaveMetering = meteringAuth;

module.exports = {
  init : function (){
    window.GoogleSubscribe = window.GoogleSubscribe || new swg();
    console.log(`Registracion Runtime: ${version}`);
  },
  forceSWGLogout : forceSWGLogout,
  saveAuth:meteringAuth,
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/app.js